module.exports = __webpack_public_path__ + "static/media/home_avatar1.60d65e22.png";